import React from 'react';
import { useAppSelector } from 'src/hooks';
import { List, ListItem, Card, CardContent, Typography, Grid, Box, IconButton, LinearProgress } from '@mui/material';
import { IReleaseNote } from '../../../../types/landing-api-response.model';

export default function ReleaseNotes() {
    const { isProductFeatureLoading, productFeatureList } = useAppSelector((state) => state.landing);

    return (
        <Box
            sx={{
                width: '100%',
                // marginTop: '5px',
                minHeight: '300px',
                overflowY: 'auto',
                padding: '0px 12px 12px 12px',
                boxSizing: 'border-box',
            }}
        >
        {isProductFeatureLoading ? (
            <div style={{ padding: '10px 0px' }}>
            <LinearProgress />
            </div>
        ) : productFeatureList?.release_notes_data? (
            <List>
                {Object.entries(productFeatureList.release_notes_data).map(
                    ([version, notes]: [string, IReleaseNote[]]) => (
                        <Card key={version} sx={{ mb: 3, backgroundColor: '#F8F9FC' }}>
                            <CardContent>
                                <Typography variant="h5" gutterBottom>
                                    Release notes for {version}
                                </Typography>
                                <Box>
                                    {notes.map((note, noteIndex) =>
                                        note.details
                                            .map((detail, detailIndex) => (
                                                <ListItem
                                                    key={`${noteIndex}-${detailIndex}`}
                                                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}
                                                >
                                                    <Grid
                                                        item
                                                        md={4}
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <IconButton
                                                            sx={{
                                                                cursor: 'auto',
                                                                padding: '2px',
                                                                marginRight: '8px',
                                                            }}
                                                        >
                                                            <img
                                                                src={`/media/${note.icon}`}
                                                                alt='icon'
                                                            />
                                                        </IconButton>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: '400',
                                                                fontSize: '12px',
                                                            }}
                                                        >
                                                            {detail.title}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item md={8}>
                                                        <Typography
                                                            variant="body2"
                                                            color={detail.market_available ? '#0000A09C' : '#ACACAC'}
                                                        >
                                                            {detail.description.join(' ')}
                                                        </Typography>
                                                    </Grid>
                                                </ListItem>
                                            ))
                                    )}
                                </Box>
                            </CardContent>
                        </Card>
                    )
                )}
            </List>)
            :(
                <div>No data found</div>
            )}
        </Box>
    );
}
